const MAPPINGS_TYPES = {
    "exactMatch" : {
        icon: "mdi-equal",
        symbol: "="
    },
    "narrowMatch" : {
        icon: "mdi-greater-than",
        symbol: ">"
    },
    "broadMatch" : {
        icon: "mdi-less-than",
        symbol: "<"
    },
    "relatedMatch" : {
        icon: "mdi-link-variant",
        symbol: "~"
    },
    "closeMatch" : {
        icon: "mdi-approximately-equal",
        symbol: "≈"
    },
    "null" : {
        icon: "",
        legend: ""
    }
};

export default MAPPINGS_TYPES;